var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M49.6169 8.37034V40.476C49.6169 44.9376 45.8987 48.5557 41.312 48.5557H33.668V29.129H40.4103L41.4664 21.6415H33.6464V18.0107C33.3145 10.6594 41.4664 13.0832 41.4664 13.0832V6.31847C27.6486 4.7115 25.9591 11.0453 25.835 13.6235L25.8667 14.6691C25.8667 14.6691 25.8249 14.4052 25.8249 13.9688V21.6415H18.96V29.2272H25.8667V48.5557H8.30483C3.71813 48.5557 0 44.9376 0 40.476V8.37034C0 3.90872 3.71813 0.291992 8.30483 0.291992H41.312C45.8987 0.291992 49.6169 3.90872 49.6169 8.37034Z"}));
}

Facebook.defaultProps = {"width":"50","height":"49","viewBox":"0 0 50 49"};

module.exports = Facebook;

Facebook.default = Facebook;
